module.exports = __webpack_public_path__ + "img/icon69.7854f738.png";